export default __webpack_public_path__ + "static/media/ph.d87b41fe.svg";